import * as React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  FormControl,
  TextField,
  Button,
  Link,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { Helmet } from 'react-helmet-async';

export default function AgentSupport(): React.JSX.Element {
  return (
    <>
      <Helmet>
        <title>Support - BVT Agent</title>
      </Helmet>
      <Box sx={{ padding: 2, maxWidth: '1200px', margin: 'auto' }}>
        <Card sx={{ marginBottom: 2 }}>
          <CardContent>
            <Typography variant="h6" component="h2" gutterBottom>
              Contact Us
            </Typography>
            {/* <Box display="flex" alignItems="center" mb={1}>
              <Typography variant="body1" sx={{ marginRight: 1 }}>
                Call us: +61 2 3456 7890
              </Typography>
            </Box> */}
            <Box display="flex" alignItems="center">
              <Typography variant="body1" sx={{ marginRight: 1 }}>
                Email: admin@vitalconsult.com.au
              </Typography>
            </Box>
          </CardContent>
        </Card>

        <Card sx={{ marginBottom: 2 }}>
          <CardContent>
            <Typography variant="h6" component="h2" gutterBottom>
              Frequently Asked Questions (FAQ)
            </Typography>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1-content" id="panel1-header">
                <Typography variant="subtitle1" fontWeight="bold">
                  How do I reset my password?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  To reset your password, click on the "Settings" in sidebar and follow the instructions.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel2-content" id="panel2-header">
                <Typography variant="subtitle1" fontWeight="bold">
                  How can I contact support?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  You can contact us via email at admin@vitalconsult.com.au. {/* or call us at +61 2 3456 7890. */}
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel3-content" id="panel3-header">
                <Typography variant="subtitle1" fontWeight="bold">
                  How do I update my profile?
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">
                  To update your profile, click on the "Profile" in sidebar and follow the instructions.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </CardContent>
        </Card>

        {/* <Card>
          <CardContent>
            <Typography variant="h6" component="h2" gutterBottom>
              Need Help? Reach out to us!
            </Typography>
            <Typography variant="body1" gutterBottom>
              If you have any further questions, feel free to reach out to us using the form below. We'll get back to you as soon as possible.
            </Typography>

            <FormControl fullWidth>
              <TextField label="Your Name" variant="outlined" sx={{ marginBottom: 2 }} required />
              <TextField label="Your Email" variant="outlined" sx={{ marginBottom: 2 }} required type="email" />
              <TextField label="Your Message" variant="outlined" multiline rows={4} sx={{ marginBottom: 2 }} required />
              <Button variant="contained" color="primary" size="large">
                Send Message
              </Button>
            </FormControl>
          </CardContent>
        </Card> */}

        {/* <Card sx={{ marginTop: 3 }}>
          <CardContent>
            <Typography variant="body2" color="textSecondary">
              © 2024 VGC Inc. All Rights Reserved.{' '}
              <Link href="#" color="inherit">
                Terms of Service
              </Link>{' '}
              |{' '}
              <Link href="#" color="inherit">
                Privacy Policy
              </Link>
            </Typography>
          </CardContent>
        </Card> */}
      </Box>
    </>
  );
}
